import { initStore } from "../../../../store/setup"
import React from "react"
import { OverlayProvider, SSRProvider } from "react-aria"
import { Provider } from "react-redux"

type Props = {
    children: React.ReactNode
}
const Providers = (props: Props) => {
    return (
        <SSRProvider>
            <OverlayProvider>
                <Provider store={initStore}>{props.children}</Provider>
            </OverlayProvider>
        </SSRProvider>
    )
}

export default Providers
